import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState } from "react";
import { Button, Divider, Flex, Modal, Radio, message, Spin, Grid } from "antd";
import { Typography } from 'antd';
import CertificateDialogDataTable from "./renewCertificateDialogDataTable";
import { processRenewalsReact } from '../../services/certificateService';
import { useSelector } from "react-redux";
import { UserActivity } from "../../config/BVConstants";
import commonService from "../../services/CommonService";
const { useBreakpoint } = Grid;
const { Text, Link } = Typography;
const radioOptions = [
    {
        label: (_jsxs(Text, { children: ["Renew this Certificate", _jsx(Link, { style: { color: "blue" }, children: " (Blue Highlighted)" })] })),
        value: "option1",
    },
    {
        label: _jsx(Text, { children: "Renew All Certificates for this Product Model" }),
        value: "option2"
    },
    {
        label: (_jsxs(Text, { children: ["Renew Specific Certificates for this Product Model", _jsx(Link, { type: "danger", children: " (Renew Specific Certificates for this Product Model)" })] })),
        value: "option3",
    },
    {
        label: (_jsxs(Text, { children: ["Do Not Renew this Certificate", _jsx(Link, { style: { color: "blue" }, children: " (Blue Highlighted)" })] })),
        value: "option4",
    },
    {
        label: _jsx(Text, { children: "Do Not Renew All Certificates for this Product Model" }),
        value: "option5",
    },
    {
        label: (_jsxs(Text, { children: ["Do Not Renew Specific Certificates for this Product Model", _jsx(Link, { type: "danger", children: " (Do Not Renew Specific Certificates for this Product Model)" })] })),
        value: "option6",
    },
];
const RenewCertificateDialog = ({ visible, handleOk, handleCancel, modelContent, modelDataTableData, reLoadData, data }) => {
    const [selectedOption, setSelectedOption] = useState("");
    const [selectedKeys, setSelectedKeys] = useState(new Set());
    const [messageApi, contextHolder] = message.useMessage();
    const [loading, setLoading] = useState(false);
    const applicationData = useSelector((state) => state === null || state === void 0 ? void 0 : state.applicationData); //useApplicationContext();
    const success = () => {
        messageApi.open({
            type: 'success',
            content: 'Renewal Processed.',
        });
    };
    const error = () => {
        messageApi.open({
            type: 'error',
            content: 'Some Error Occured.',
        });
    };
    const warning = () => {
        messageApi.open({
            type: 'warning',
            content: 'Please select any one option to process.',
        });
    };
    const onChange = (e) => {
        setSelectedOption(e.target.value);
    };
    const onSelectedKeysChange = (keys) => {
        setSelectedKeys(keys);
    };
    const onSubmit = () => {
        var _a, _b, _c, _d, _e, _f;
        let intRenewalOption = 0;
        if (selectedOption === "option1") {
            intRenewalOption = 1;
        }
        if (selectedOption === "option2") {
            intRenewalOption = 2;
        }
        if (selectedOption === "option3") {
            intRenewalOption = 3;
        }
        if (selectedOption === "option4") {
            intRenewalOption = 4;
        }
        if (selectedOption === "option5") {
            intRenewalOption = 5;
        }
        if (selectedOption === "option6") {
            intRenewalOption = 6;
        }
        if (intRenewalOption == 0) {
            warning();
            return;
        }
        if (modelDataTableData) {
            Array.from(selectedKeys).forEach(key => {
                if (modelDataTableData[key]) {
                    modelDataTableData[key].boolSelectedForRenewal = true;
                }
            });
        }
        let objCertNotification = modelContent;
        let companyId = null;
        if (modelContent && data) {
            objCertNotification = data.find(item => item.intUniqueCertificateId === modelContent.intUniqueCertificateId);
            companyId = (_b = (_a = data.find(item => item.intUniqueCertificateId === modelContent.intUniqueCertificateId)) === null || _a === void 0 ? void 0 : _a.objLuCompany) === null || _b === void 0 ? void 0 : _b.intId;
        }
        const processRenewalsData = {
            intRenewalOption: intRenewalOption,
            intCompanyId: companyId,
            objCertNotification: objCertNotification,
            objTblUserDetails: {
                objUser: {
                    strEmail: (_d = (_c = applicationData === null || applicationData === void 0 ? void 0 : applicationData.loggedInClient) === null || _c === void 0 ? void 0 : _c.userLoginDetails) === null || _d === void 0 ? void 0 : _d.strUserEmailId
                }
            },
            lstCertNotificationRenwals: modelDataTableData
        };
        setLoading(true);
        processRenewalsReact(processRenewalsData).then((res) => {
            setLoading(false);
            if (res === "Success") {
                handleOk();
                success();
                reLoadData();
            }
            else {
                error();
            }
        });
        commonService
            .logUserActivity((_f = (_e = applicationData === null || applicationData === void 0 ? void 0 : applicationData.loggedInClient) === null || _e === void 0 ? void 0 : _e.userLoginDetails) === null || _f === void 0 ? void 0 : _f.strUserEmailId, UserActivity.CP__CertMgmt_Renewal_Update);
    };
    const screens = useBreakpoint();
    return (_jsxs(_Fragment, { children: [contextHolder, _jsxs(Modal, { title: "Renew Certificate(s)", open: visible, onOk: handleOk, onCancel: handleCancel, footer: [
                    _jsx(Button, { onClick: handleCancel, children: "Cancel" }, "back"),
                    _jsx(Button, { type: "primary", onClick: onSubmit, children: "Submit" }, "submit")
                ], width: screens.xs ? "95%" : "75%", children: [_jsx(Divider, { style: { margin: '10px 0px' } }), _jsx(Spin, { spinning: loading, children: _jsxs(Flex, { vertical: true, gap: 5, children: [_jsx(Radio.Group, { onChange: onChange, value: selectedOption, size: "small", children: _jsx(Flex, { vertical: true, children: radioOptions === null || radioOptions === void 0 ? void 0 : radioOptions.map(item => (_jsx(Radio, { value: item.value, children: item.label }, item.value))) }) }), _jsxs("div", { style: { display: 'flex', justifyContent: 'space-between', width: '100%' }, children: [_jsxs("div", { style: { textAlign: 'left' }, children: [_jsx("b", { children: "Entity Name:" }), " ", modelContent === null || modelContent === void 0 ? void 0 : modelContent.entityname] }), _jsxs("div", { style: { textAlign: 'center' }, children: [_jsx("b", { children: "Product Model:" }), " ", modelContent === null || modelContent === void 0 ? void 0 : modelContent.productmodel] }), _jsxs("div", { style: { textAlign: 'right' }, children: [_jsx("b", { children: "Total Records:" }), " ", modelDataTableData === null || modelDataTableData === void 0 ? void 0 : modelDataTableData.length] })] }), _jsx(CertificateDialogDataTable, { data: modelDataTableData === null ? undefined : modelDataTableData, radioBoxCheckBox: selectedOption, onSelectedKeysChange: onSelectedKeysChange })] }) })] })] }));
};
export default RenewCertificateDialog;
